<template>
  <div class="container">
    <article class="message is-danger" v-if="!superuser">
      <div class="message-body">
        You have not signed in yet. Please go back to <a href="/">home page</a> to sign in first.
      </div>
    </article>

    <section class="section" v-if="superuser">
      <h1 class="title is-4">Dev tools</h1>

      <product-updater />

      <hr />

      <h1 class="title is-4">Compute sale speed</h1>

      <div class="field mt-5">
        <label class="label">Sale Speed</label>
      </div>
      <div class="field has-addons">
        <p class="control is-expanded">
          <input v-model="saleSpeedProductId" class="input" type="text" placeholder="Product Id">
        </p>
        <p class="control">
          <button class="button is-link" @click="computeSaleSpeed">
            Compute
          </button>
        </p>
      </div>

      <hr />
      <h1 class="title is-4">NetSuite callers</h1>

      <div class="field mt-5">
        <label class="label">Get Resource</label>
      </div>
      <div class="field has-addons">
        <p class="control is-expanded">
          <input v-model="netsuitePath" class="input" type="text" placeholder="Resource Path">
        </p>
        <p class="control">
          <button class="button is-link" @click="testNetsuite">
            Get Resource
          </button>
        </p>
      </div>

      <div class="field mt-5">
        <label class="label">Call Restlet</label>
      </div>
      <div class="field has-addons">
        <p class="control">
          <span class="select">
            <select v-model="restletMethod">
              <option>GET</option>
              <option>POST</option>
            </select>
          </span>
        </p>
        <p class="control">
          <input v-model="restletScript" class="input" type="text" placeholder="Script">
        </p>
        <p class="control">
          <input v-model="restletDeploy" class="input" type="text" placeholder="Deploy">
        </p>
        <p class="control is-expanded">
          <input v-model="restletParams" class="input" type="text" placeholder="Params/body in json">
        </p>
        <p class="control">
          <button class="button is-link" @click="callNetsuiteRestlet">
            Call Restlet
          </button>
        </p>
      </div>

      <hr />
      <h1 class="title is-4">Test Sharepoint</h1>

      <div class="field mt-5">
        <label class="label">Get Folder</label>
      </div>
      <div class="field has-addons">
        <p class="control is-expanded">
          <input v-model="sharepointPath" class="input" type="text" placeholder="Path">
        </p>
        <p class="control">
          <button class="button is-link" @click="testSharepoint">
            Get folder
          </button>
        </p>
      </div>

    </section>
  </div>
</template>

<script>
import ProductUpdater from '@/components/price-monitor/ProductUpdater'

export default {
  name: 'DevTools',
  components: {
    ProductUpdater
  },
  data () {
    return {
      netsuitePath: '',
      restletMethod: 'GET',
      restletScript: '',
      restletDeploy: '',
      restletParams: '',
      saleSpeedProductId: '',
      sharepointPath: '',
    }
  },
  computed: {
    server () {
      return this.$store.state.config.server
    },
    superuser () {
      return this.$store.state.user.superuser
    },
  },
  methods: {
    testNetsuite () {
      this.$http.post(this.server + '/myapp/test-netsuite/', {path: this.netsuitePath}).then(resp => {
        console.log('NS resource: ', resp.body)
      })
    },
    testSharepoint () {
      this.$http.post(this.server + '/myapp/test-sharepoint/', {path: this.sharepointPath}).then(resp => {
        console.log('test sharepoint result: ', resp.body)
      })
    },
    callNetsuiteRestlet () {
      var data = {
        method: this.restletMethod.trim(),
        script: this.restletScript.trim(),
        deploy: this.restletDeploy.trim(),
        params: this.restletParams.trim(),
      }
      this.$http.post(this.server + '/myapp/call-netsuite-restlet/', data).then(resp => {
        console.log('Restlet resp', resp.body)
      })
    },
    computeSaleSpeed () {
      var data = {productId: this.saleSpeedProductId}
      this.$http.post(this.server + '/myapp/compute-sale-speed-for-product/', data)
    },
  },
  mounted () {
  }
}
</script>